export default [
  {
    id: Math.random(),
    title: 'My first To-Do',
    createdAt: new Date(2020, 3, 10),
    done: true,
  },
  {
    id: Math.random(),
    title: 'My Second To-Do',
    createdAt: new Date(2020, 3, 11),
    done: false,
  },
  {
    id: Math.random(),
    title: 'My Third To-Do',
    createdAt: new Date(2020, 3, 12),
    done: false,
  },
];
